import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebookF, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
//CSS
import './style.css';
//
export default function Team(props){
    return(
        <section id={props.id} className="team-member-section pt-5 pb-5">
            <Container>
                <Row className="justify-content-center">
                    <Col lg={7} md={8}>
                        <div className="section-heading text-center mb-5">
                            <h2>{props.title}</h2>
                            <p className="lead">
                                {props.text}
                            </p>
                        </div>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    {props.teamList.map((item, i)=>
                        <Col lg={3} sm={6} key={i}>
                            <div className="single-team-member position-relative">
                                <div className="team-image">
                                    <img src={item.img} alt="Team Members" className="img-fluid rounded-circle"/>
                                </div>
                                <div className="team-info text-white rounded-circle d-flex flex-column align-items-center justify-content-center">
                                    <h5 className="mb-0">{item.name}</h5>
                                    <h6>{item.office}</h6>
                                    <ul className="list-inline team-social social-icon mt-4 text-white">
                                        {item.facebook ? <li className="list-inline-item"><a href={item.facebook}><span className="text-white"><FontAwesomeIcon icon={faFacebookF}/></span></a></li> : <></>}
                                        {item.instagram ? <li className="list-inline-item"><a href={item.instagram}><span className="text-white"><FontAwesomeIcon icon={faInstagram}/></span></a></li> : <></>}
                                        {item.linkedin ? <li className="list-inline-item"><a href={item.linkedin}><span className="text-white"><FontAwesomeIcon icon={faLinkedinIn}/></span></a></li> : <></>}
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    )}
                </Row>
            </Container>
        </section>
    );
}